<template>
  <card>
    <h5 slot="header" class="title">Edit Profile</h5>
    <form @submit.prevent="updateProfile">
      <div class="row">
        <div class="col-md-5">
          <base-input
            type="text"
            label="Company"
           
            placeholder="Company"
            v-model="user.company"
          >
          </base-input>
        </div>
        <div class="col-md-3">
          <base-input
            type="text"
            label="Building size"
            placeholder="Building size in sq. ft."
            v-model="user.size"
          >
          </base-input>
        </div>
        <div class="col-md-4">
          <base-input
            type="email"
             :disabled="true"
            label="Email address"
            placeholder="email"
            v-model="user.email"
          >
          </base-input>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <base-input
            type="text"
            label="First Name"
            placeholder="First Name"
            v-model="user.firstName"
          >
          </base-input>
        </div>
        <div class="col-md-6">
          <base-input
            type="text"
            label="Last Name"
            placeholder="Last Name"
            v-model="user.lastName"
          >
          </base-input>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <base-input
            type="text"
            label="Address"
            placeholder="Home Address"
            v-model="user.address"
          >
          </base-input>
        </div>
      </div>

      <div class="row">
        <div class="col-md-4">
          <base-input
            type="text"
            label="City"
            placeholder="City"
            v-model="user.city"
          >
          </base-input>
        </div>
        <div class="col-md-4">
          <base-input
            type="text"
            label="Country"
            placeholder="Country"
            v-model="user.country"
          >
          </base-input>
        </div>
        <div class="col-md-4">
          <base-input
            label="Postal Code"
            placeholder="ZIP Code"
            v-model="user.postalCode"
          >
          </base-input>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <base-input label="About Me">
            <textarea
              class="form-control"
              placeholder="ZIP Code"
              v-model="user.aboutMe"
            >
            </textarea>
          </base-input>
        </div>
      </div>

      <base-button native-type="submit" type="primary" class="btn-fill">
        Save
      </base-button>
    </form>
  </card>
</template>
<script>

import firebase from '../../../Firebase';



export default {
  data() {
    return {
       uid:"",
      user: {
        company: '',
        size: '',
        email: '',
        firstName: '',
        lastName: '',
        address: '',
        city: '',
        country: '',
        postalCode: '',
        aboutMe: ``
      }
    };
  },
  created(){
      const currentUser = firebase.auth().currentUser
  this.uid = currentUser.uid;
 firebase.database().ref('users').child(this.uid).on("value",user=>{

    this.user.company = user.child("company").val()
    this.user.size = user.child("size").val()
    this.user.email = user.child("email").val()
    this.user.firstName = user.child("firstName").val()
    this.user.lastName = user.child("lastName").val()
    this.user.address = user.child("address").val()
    this.user.city = user.child("city").val()
    this.user.country = user.child("country").val()
    this.user.postalCode = user.child("postalCode").val()
    this.user.aboutMe = user.child("aboutMe").val()
  

 });


  },

  methods: {
    updateProfile() {
     // alert('Your data: ' + JSON.stringify(this.user));
      alert('Your profile has been uptaded!');

      firebase.database().ref('users').child(this.uid).update(this.user)
    }
  }
};
</script>
<style></style>
